import camelcase from 'camelcase';

let exportEnv = {
  apiHost: null,
  smorderEnv: null,
  positiveCardCTA: 'Kann ich',
  negativeCardCTA: 'Kann ich nicht',
  useCaptcha: false,
  forbidCompanySignup: true,
};


const brandSpecificOptions = (brand) => {
  if (brand == 'whitelabel') {
    return {
      brand,
      title: 'Smart Learning',
      gaID: 'UA-108077141-2',
      hasLandingpage: false,
      copyright: 'Plappermaul OG',
      usermanagement: true,
      youtubeFeature: true,
      searchFeature: true,
      exportFeature: true,
      useCaptcha: true,
      captchaClientKey: '6Lc-v9sUAAAAACEhlzuxDGAu-JIwFhVe9_2pHlUL',
    };
  }

  if (brand == 'rlboe') {
    return {
      brand,
      title: 'RLB-Learning',
      gaID: 'UA-108077141-2',
      hasLandingpage: false,
      copyright: 'Plappermaul OG',
      usermanagement: true,
      youtubeFeature: true,
      searchFeature: true,
      exportFeature: true,
      useCaptcha: true,
      forbidSignup: true,
      forbidToChangePassword: true,
      captchaClientKey: '6Lc-v9sUAAAAACEhlzuxDGAu-JIwFhVe9_2pHlUL',
      impressUrl: 'https://www.raiffeisen.at/ooe/rlb/de/meine-bank/agb-impressum.html',
      privacyUrl: 'https://www.raiffeisen.at/ooe/rlb/de/meine-bank/agb-impressum.html',
    };
  }

  if (brand == 'eba') {
    return {
      brand,
      title: 'EBA',
      gaID: 'UA-107947006-1',
      hasLandingpage: true,
      copyright: 'WKO Bundesgremium des Elektro- und Einrichtungsfachhandels',
      usermanagement: false,
      youtubeFeature: false,
      searchFeature: true,
      exportFeature: true,
      forbidCompanySignup: true,
      playStoreUrl: 'https://play.google.com/store/apps/details?id=com.smartlearningapp',
      appStoreUrl: 'https://itunes.apple.com/us/app/eba-einrichtungsberater-app/id1276331495?ls=1&mt=8',
    };
  }

  if (brand == 'rlb') {
    return {
      brand,
      title: 'Raiffeisen Mein Coach',
      gaID: 'UA-108077141-2',
      hasLandingpage: false,
      copyright: 'RLB NÖW AG',
      usermanagement: true,
      doNotRenderOptionalSignupField: true,
      doNotRenderBirthdaySelection: true,
      youtubeFeature: true,
      searchFeature: false,
      exportFeature: false,
      unlinkedHeaderLogo: true,
      positiveCardCTA: 'Gemerkt',
      negativeCardCTA: 'Wiederholen',
      usePasswordConfirmationField: true,
      impressUrl: 'http://www.raiffeisenbank.at/eBusiness/01_template1/1015018521967-NA-1025194088564-NA-30-NA.html',
    };
  }

  if (brand == 'kutsam') {
    return {
      brand,
      title: 'Know Kutsam',
      gaID: 'UA-108077141-2',
      hasLandingpage: false,
      copyright: 'Kutsam',
      usermanagement: true,
      doNotRenderOptionalSignupField: true,
      doNotRenderBirthdaySelection: true,
      youtubeFeature: true,
      searchFeature: true,
      exportFeature: true,
      unlinkedHeaderLogo: true,
      positiveCardCTA: 'Gemerkt',
      negativeCardCTA: 'Wiederholen',
      usePasswordConfirmationField: true,
      impressUrl: 'https://kutsam.at/kontakt/impressum',
    };
  }

  if (brand == 'customerexpert') {
    return {
      brand,
      title: 'Customer Expert',
      hasLandingpage: true,
      youtubeFeature: true,
      doNotRenderBirthdaySelection: true,
      searchFeature: true,
      exportFeature: true,
      impressUrl: 'https://www.wko.at/branchen/handel/baustoff-eisen-hartwaren-holzhandel/Offenlegung.html',
      privacyUrl: 'https://www.wko.at/service/datenschutzerklaerung.html',
    };
  }

  if (brand == 'msl') {
    return {
      brand,
      title: 'Smarter Lernen',
      isPlatformSolution: true,
      copyright: 'Smarter Lernen',
      youtubeFeature: true,
      searchFeature: true,
      exportFeature: true,
      forbidCompanySignup: false,
      impressUrl: 'https://smarterlernen.at/impressum',
      privacyUrl: 'https://smarterlernen.at/privacy',
    };
  }
};


Object.keys(process.env).forEach((key) => {
  if (key.indexOf('REACT_APP_') === -1) {
    return;
  }
  const mappedKeyName = camelcase(key.replace('REACT_APP_', ''));
  exportEnv[mappedKeyName] = process.env[key];
});

exportEnv = Object.assign(exportEnv, brandSpecificOptions(exportEnv.brand));
console.log(exportEnv);
export default exportEnv;



// WEBPACK FOOTER //
// ./src/run-config.js